import { combineReducers } from 'redux'

import { SET_LOADING, SET_USER_INFO, SET_IS_LOGIN, SET_BANNER, SET_SHOW_CATEGORY } from './action.js'

const initialShow = {
    showSubCategory: false,
}

const show = (state = initialShow, action) => {
    switch (action.type) {
        case SET_SHOW_CATEGORY:
            return Object.assign({}, state, { showSubCategory: action.showSubCategory })
        default:
            return state
    }
}

const initialUser = {
    userInfo: null,
    isLogin: false,
}

const user = (state = initialUser, action) => {
    switch (action.type) {
        case SET_USER_INFO:
            return Object.assign({}, state, { userInfo: action.userInfo })
        case SET_IS_LOGIN:
            return Object.assign({}, state, { isLogin: action.isLogin })
        default:
            return state
    }
}

const initDataLoading = {
    isLoading: false,
    banner: {},
}
const common = (state = initDataLoading, action) => {
    switch (action.type) {
        case SET_LOADING:
            return Object.assign({}, state, { isLoading: action.isLoading })
        case SET_BANNER:
            return Object.assign({}, state, { banner: action.banner })
        default:
            return state
    }
}

// 검색
const initialData = {
    searchWord: '', // 검색어
    searchWordHighlight: '', // 검색어강조
    searchLayer: false, // 검색하단 레이어
    searchDetailLayer: false, // 상세검색 레이어
    searchLayerTab: 'latest', // 검색탭 - 최근검색어: latest, 인기검색어: popular, 자동완성: auto
    searchLatestDelete: false, // 기록 삭제 모드
    searchLayerTabView: {
        // 검색어저장, 자동완성 on off
        latest: true,
        auto: true,
    },
    searchList: [], // 검색어 리스트
    popularList: [
        // 인기검색어 리스트
        // { id: 1, s: '행복쇼핑', diff: 0 },
        // { id: 2, s: '맥북 16인치', diff: 1 },
        // { id: 3, s: '코로나 19', diff: 2 },
        // { id: 4, s: '마스크', diff: 0 },
        // { id: 5, s: '이탈리아', diff: 3 },
        // { id: 6, s: '구로콜센터 확진자', diff: 2 },
        // { id: 7, s: '하정우', diff: 0 },
        // { id: 8, s: '기사시험 연기', diff: 3 },
        // { id: 9, s: '스테파니 리', diff: 1 },
        // { id: 10, s: '벤틀리', diff: 0 },
    ],
    autoList: [
        // 자동완성 리스트
        // { s: '행복e음시스템' },
        // { s: '행복주택' },
        // { s: '행복쇼핑' },
        // { s: '행정안전부' },
        // { s: '행거' },
        // { s: '국민행복카드' },
        // { s: '행아웃' },
        // { s: '한국해양대학교' },
        // { s: '해운대구청' },
        // { s: '아이행복카드' },
    ],
    searchKeywordAdv: null,
}

export const SEARCH_WORD = 'SEARCH_WORD'
export const SEARCH_WORD_HIGHLIGHT = 'SEARCH_WORD_HIGHLIGHT'
export const SEARCH_LAYER = 'SEARCH_LAYER'
export const SEARCH_DETAIL_LAYER = 'SEARCH_DETAIL_LAYER'
export const SEARCH_LAYER_TAB = 'SEARCH_LAYER_TAB'
export const SEARCH_LATEST_DELETE = 'SEARCH_LATEST_DELETE'
export const SEARCH_LAYER_TAB_VIEW = 'SEARCH_LAYER_TAB_VIEW'
export const SEARCH_LIST_INSERT = 'SEARCH_LIST_INSERT'
export const SEARCH_LIST_DELETE = 'SEARCH_LIST_DELETE'
export const SEARCH_POPULAR_LIST_INSERT = 'SEARCH_POPULAR_LIST_INSERT'
export const SEARCH_AUTO_LIST_INSERT = 'SEARCH_AUTO_LIST_INSERT'
export const SEARCH_LIST_FOCUS_CLEAR = 'SEARCH_LIST_FOCUS_CLEAR'
export const SET_SEARCH_KEYWORD_ADV = 'SET_SEARCH_KEYWORD_ADV'

const search = (state = initialData, action) => {
    switch (action.type) {
        case SEARCH_WORD:
            return {
                ...state,
                searchWord: action.data,
            }
        case SEARCH_WORD_HIGHLIGHT:
            return {
                ...state,
                searchWordHighlight: action.data,
            }
        case SEARCH_LIST_FOCUS_CLEAR:
            const searchist = [...state.searchList]
            const popularList = [...state.popularList]
            const autoList = [...state.autoList]
            let searchClone = searchist.map((v) => ({ ...v, focus: false }))
            let popularClone = popularList.map((v) => ({ ...v, focus: false }))
            let autoClone = autoList.map((v) => ({ ...v, focus: false }))
            return {
                ...state,
                searchList: searchClone,
                popularList: popularClone,
                autoList: autoClone,
            }
        case SEARCH_LAYER:
            return {
                ...state,
                searchLayer: action.data,
            }
        case SEARCH_DETAIL_LAYER:
            return {
                ...state,
                searchDetailLayer: action.data,
            }
        case SEARCH_LAYER_TAB:
            return {
                ...state,
                searchLayerTab: action.data,
            }
        case SEARCH_LATEST_DELETE:
            return {
                ...state,
                searchLatestDelete: action.data,
            }
        case SEARCH_LAYER_TAB_VIEW:
            return {
                ...state,
                searchLayerTabView: action.data,
            }
        case SEARCH_LIST_INSERT:
            return {
                ...state,
                searchList: action.data,
            }
        case SEARCH_LIST_DELETE:
            return {
                ...state,
                searchList: action.data,
            }
        case SEARCH_POPULAR_LIST_INSERT:
            return {
                ...state,
                popularList: action.data,
            }
        case SEARCH_AUTO_LIST_INSERT:
            return {
                ...state,
                autoList: action.data,
            }
        case SET_SEARCH_KEYWORD_ADV:
            return {
                ...state,
                searchKeywordAdv: action.data,
            }
        default:
            return state
    }
}

export default combineReducers({ user, common, show, search })



// WEBPACK FOOTER //
// ./src/header/libs/reducer.js